import Mantra from './mantra';

window.mantra = new Mantra(document.getElementById('mantra'));
